<template>
    <p><a href="#" @click.prevent="volver()" class="home"><i class="fas fa-home"></i> Volver</a></p>
</template>

<script>

export default {
    name: 'BtnVolver',
    methods: {
        volver(){
            this.$emit('click');
        }
    }
}
</script>

<style lang="scss" scoped>
.home {
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    &:hover {
        color: #d0112b;
    }

    i {
        font-size: 1.5em;
        margin: 0 5px;
    }
}
</style>
